/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { createMemoRequestDtoSchema } from "../createMemoRequestDtoSchema";
import { z } from "zod/v4";

export const createMemoHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Memo created.
 */
export const createMemo201Schema = z.any()

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const createMemo401Schema = z.any()

export const createMemoMutationRequestSchema = z.lazy(() => createMemoRequestDtoSchema)

export const createMemoMutationResponseSchema = z.lazy(() => createMemo201Schema)